import { useEffect, useRef } from 'react'
import { useQuery } from '@tanstack/react-query'
import { applyColorsToDocument, fetchBrandColors } from '@/api/theme-colors'
import { useAdminTheme } from '@/hooks/useAdminLayoutPreferences'

export function ThemeColorProvider({ children }: { children: React.ReactNode }) {
  const { mode } = useAdminTheme()
  const colorDataRef = useRef<typeof data>(undefined)

  const { data } = useQuery({
    queryKey: ['brand-colors'],
    queryFn: fetchBrandColors,
    staleTime: 5 * 60 * 1000,
    retry: false,
  })

  useEffect(() => {
    if (data) colorDataRef.current = data
  }, [data])

  useEffect(() => {
    if (colorDataRef.current) applyColorsToDocument(colorDataRef.current)
  }, [mode])

  return <>{children}</>
}
